import React from 'react';
import ReactDOM from 'react-dom';
import AppContainer from './containers/AppContainer';

// ========================================================
// Render Setup
// ========================================================
const MOUNT_NODE = document.getElementById('root');
import ROUTES from './routes';

let render = () => {

  ReactDOM.render(
    <AppContainer routes={ ROUTES } />,
    MOUNT_NODE
  );
};

// This code is excluded from production bundle
if (__DEV__) {
  if (module.hot) {
    // Development render functions

    // Moves render function defined above to here
    const renderApp = render;

    // Wrap render in try/catch, and replace original reference
    render = () => {
      try {
        renderApp();
      } catch (error) {
      }
    };

    // Setup hot module replacement
    module.hot.accept('./routes/index', () =>
      /* eslint-disable no-undef */
      setImmediate(() => {
        ReactDOM.unmountComponentAtNode(MOUNT_NODE);
        render();
      })
      /* eslint-enable no-undef */
    );
  }
}

// ========================================================
// Go!
// ========================================================
render();



// WEBPACK FOOTER //
// ./src/main.js